/**
 * @file Place here "temporary" methods used to sanitize data for code modernization.
 * No matter to the code quality here.
 */

import CourseOrder from './../class/CourseOrder';

/**
 * Transform data objects representing a course order to a typed version CourseOrder.
 */
export function courseToOrder(
    courseData: any,
    city: any,
    quantity: number,
    price: number,
    currency: any,
    bookingReference: string | null,
    ticketData: any,
    event: any
) {
    // Course can be in stand alone, with a discount,
    // but it also can come from a pack of courses
    // for a details display, and so inherit a discounted price.
    const priceDiscounted = ticketData.isFromPack
        ? ticketData.ticket_type.cost * 0.85
        : ticketData.discounted_price;

    return new CourseOrder(
        (window as any)['app'],
        ticketData.id,
        city,
        'course',
        courseData,
        quantity,
        price,
        ticketData.coupon,
        priceDiscounted,
        currency,
        !ticketData.coupon,
        bookingReference,
        [event],
        ticketData.is_last_minute || false
    );
}

/**
 * Transform data objects representing a course order to a typed version CourseOrder.
 */
export function packToOrder(
    packData: any,
    city: any,
    quantity: number,
    price: number,
    currency: any,
    bookingReference: string | null
) {
    return new CourseOrder(
        (window as any)['app'],
        packData.cartItemId,
        city,
        'pack',
        packData,
        quantity,
        price,
        packData.coupon,
        packData.discountedPrice,
        currency,
        false,
        bookingReference,
        [],
        false // Packs don't have last minute discount
    );
}
